import React, { useState } from 'react';
import { func, shape, string } from 'prop-types';

import DataTypeSelect from '../FormFields/DataTypeSelect';

const BacnetDataTypeSelect = ({
    name,
    onChange,
    rowData,
    ...props
}) => {
    const rowValue = rowData.dataType === 'unknown' ? '' : rowData.dataType;
    const [value, setValue] = useState(rowValue);

    function handleChange(event) {
        const { value } = event.target;

        rowData.dataType = value;

        setValue(value);
        onChange(rowData);
    }

    return (
        <DataTypeSelect
            name={name}
            onChange={handleChange}
            showLabel={false}
            value={value}
        />
    );
};

BacnetDataTypeSelect.defaultProps = {
    onChange: () => {},
    rowData:  {}
};

BacnetDataTypeSelect.propTypes = {
    name:     string,
    onChange: func,
    rowData:  shape({
        id: string
    })
};

export default BacnetDataTypeSelect;
